import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseBranches, ApiResponseAcademyBranches } from '@/api/responses/manage/branches'

export namespace BranchesApi {
  /**
   * 教室一覧取得(プルダウン選択肢)
   *
   * @returns 教室一覧
   */
  export async function getBranches(): Promise<ApiResponseAcademyBranches> {
    return await ApiBase.get('/manage/branches')
  }

  /**
   * 教室一覧取得(ページング付一覧表示)
   *
   * @param searchText 検索文字列
   * @param pageNumber ページ番号
   * @param count 取得件数
   * @returns 教室一覧
   */
  export async function searchBranches(
    searchText: string | null,
    pageNumber: number,
    count: number
  ): Promise<ApiResponseBranches> {
    const params = {
      searchText: searchText,
      pageNumber: pageNumber,
      count: count,
    }
    return await ApiBase.get('/manage/branches/search', params)
  }
}
